import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import EmailFloat from "@/components/EmailFloat";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  // Hide / remove the platform-injected "Made with Emergent" badge.
  useEffect(() => {
    const kill = () => {
      const el = document.getElementById("emergent-badge");
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
    kill();
    const obs = new MutationObserver(kill);
    obs.observe(document.body, { childList: true, subtree: false });
    const id = window.setInterval(kill, 1000);
    return () => {
      obs.disconnect();
      window.clearInterval(id);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col text-[color:var(--zp-text)]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <EmailFloat />
      <WhatsAppFloat />
    </div>
  );
}
